import { ISearchBoxStyleProps, ISearchBoxStyles } from '@fluentui/react/lib/SearchBox';
import { concatStyleSets, ITheme } from '@fluentui/react/lib/Styling';
import { IStyleFunctionOrObject, memoizeFunction } from '@fluentui/react/lib/Utilities';

import { getStandardControlSemanticColorsWithTheme, StandardControlSemanticColors } from '@1js/acui-common';

/**
 * Styles from Fabric UI are overwritten here to prevent visual regression.
 */
export const getAppSearchBoxStyles: (
  theme: ITheme,
  hasIcon?: boolean,
  customStyles?: IStyleFunctionOrObject<ISearchBoxStyleProps, ISearchBoxStyles> | undefined
) => ISearchBoxStyles = memoizeFunction(
  (
    theme: ITheme,
    hasIcon?: boolean,
    customStyles?: IStyleFunctionOrObject<ISearchBoxStyleProps, ISearchBoxStyles>
  ): ISearchBoxStyles => {
    const standardControlSemanticColors: StandardControlSemanticColors = getStandardControlSemanticColorsWithTheme(
      theme
    );
    const searchBoxStyles: ISearchBoxStyles = {
      root: [
        {
          position: 'relative',
          background: standardControlSemanticColors.defaultBackgroundColor,
          selectors: {
            'input[type="search"]::-webkit-search-cancel-button': {
              display: 'none',
            },
          },
        },
      ],
      iconContainer: hasIcon && {
        marginLeft: '5px',
      },
      icon: hasIcon && {
        height: '20px',
        width: '20px',
      },
    };

    return concatStyleSets(searchBoxStyles, customStyles);
  }
);

export const getAppSearchBoxStylesInMLRMenu: (
  hasIcon?: boolean | undefined,
  customStyles?: IStyleFunctionOrObject<ISearchBoxStyleProps, ISearchBoxStyles> | undefined
) => Partial<ISearchBoxStyles> = memoizeFunction(
  (
    hasIcon?: boolean,
    customStyles?: IStyleFunctionOrObject<ISearchBoxStyleProps, ISearchBoxStyles> | undefined
  ): Partial<ISearchBoxStyles> => {
    const searchBoxMenuStyles = {
      icon: hasIcon && {
        height: '16px',
        width: '16px',
      },
    };
    return concatStyleSets(searchBoxMenuStyles, customStyles);
  }
);
